<template>
  <div id="app">
    <KeepAlive>
      <router-view />
    </KeepAlive>
  </div>
</template>
<script>
export default {
  name: 'App',
}
</script>
<style lang="less">
</style>
